import { localStore } from "./client";
import type { TriageNote } from "../types";
import { addDecisionLogEntry } from "./actions";

/**
 * Add a triage note to a ticket (local storage for prototype).
 */
export function addTriageNote(
  ticketId: string,
  content: string,
  author: string = "folaok"
): TriageNote {
  const allNotes = localStore.get<Record<string, TriageNote[]>>("triageNotes", {});
  const notes = allNotes[ticketId] || [];

  const note: TriageNote = {
    noteId: `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`,
    author,
    content,
    createdAt: new Date().toISOString(),
  };

  notes.unshift(note);
  allNotes[ticketId] = notes;
  localStore.set("triageNotes", allNotes);

  addDecisionLogEntry({
    ticketId,
    timestamp: note.createdAt,
    actionType: "NOTE_ADDED",
    actor: author,
    details: content.substring(0, 200),
  });

  return note;
}

/**
 * Get triage notes for a ticket.
 */
export function getTriageNotes(ticketId: string): TriageNote[] {
  const allNotes = localStore.get<Record<string, TriageNote[]>>("triageNotes", {});
  return allNotes[ticketId] || [];
}
